import auth from './auth'
import user from './user'
import ui from './ui'
import popup from './popup'

export default {
  auth,
  user,
  ui,
  popup,
}
